import React from "react";
import Utils from "../utils/Utils.js";
import "../styles/UserManagmentUsers.css";
import SearchIcon from "../icons/BusinessHub/SearchIcon.js";
import FilterIcon from "../icons/BusinessHub/FilterIcon.js";
import ExportIcon from "../icons/BusinessHub/ExportIcon.js";
import { useEffect, useState, useRef } from "react";
import { createRequestHandler, useNavigate } from "react-router-dom";
import ArrowBackIcon from "../icons/BusinessHub/ArrowBackIcon.js";
import ArrowFront from "../icons/BusinessHub/ArrowFront.js";
import ThreeDots from "../icons/BusinessHub/ThreeDots.js";
import Waiting from "../icons/BusinessHub/WaitingIcon.js";
import Active from "../icons/BusinessHub/ActiveIcon.js";
import RemoveUser from "../icons/BusinessHub/RemoveUserIcon.js";
import EditDetails from "../icons/BusinessHub/EditDetails.js";
import ReactCountryFlag from "react-country-flag";
import BinIcon from "../icons/BusinessHub/BinIcon.js";
import CloseIcon from "../icons/SignInIcon/closeIcon.js";
import CountriesController from "../controllers/CountriesController.js";
import companyController from "../controllers/companyController.js";
import AccCyrcleIcon from "../icons/BusinessHub/AccCyrcleIcon.js";
import { toast } from "react-toastify";
import { userService } from "../services/userService";
import userController from "../controllers/userController.js";

const formatStatus = (status) =>
  status
    ? status
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";

function UserManagmentUsers() {
  const navigate = useNavigate();
  const popupRef = useRef(null);
  const [RowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selected, setSelected] = useState([]);
  const [actiondiv, setactiondiv] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const statusRequestPending = useRef(false);
  const [updatingUserId, setUpdatingUserId] = useState(null);

  const [jwt, setjwt] = useState("");
  // const [companyID, setCompanyID] = useState("");
  const [countries, setCountries] = useState([]);
  const [value, setValue] = useState("");
  const [userId, setUserId] = useState("");
  const [refreshEmployees, setRefreshEmployees] = useState(false);
  const [OID, setOID] = useState();
  const companyID = userService.getCompID();
  useEffect(() => {
    setjwt(userService.getUser());
  }, []);

  const handleEditClick = (userId, roleName) => {
    navigate("/edit-user-details", {
      state: { userId, roleName },
    });
  };

  const handleactiondiv = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setOpenIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const allChecked =
    Array.isArray(data) &&
    data.length > 0 &&
    data.every((u) => selected.includes(u.userId));

  const toggleAll = (e) => {
    if (e.target.checked) {
      setSelected((prev) => [
        ...new Set([...prev, ...data.map((item) => item.userId)]),
      ]);
    } else {
      setSelected((prev) =>
        prev.filter((userId) => !data.some((item) => item.userId === userId)),
      );
    }
  };

  const toggleOne = (userId) => {
    setSelected((prev) =>
      prev.includes(userId)
        ? prev.filter((x) => x !== userId)
        : [...prev, userId],
    );
  };

  const getPages = () => {
    const pages = [];

    pages.push(1);

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (currentPage <= 2) {
      start = 2;
      end = Math.min(3, totalPages - 1);
    }

    if (currentPage >= totalPages - 1) {
      start = Math.max(2, totalPages - 2);
      end = totalPages - 1;
    }

    if (start > 2) pages.push("ellipsis");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) pages.push("ellipsis");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // useEffect(() => {
  //   if (!jwt) return;
  //   const parsed = Utils.parseJwt(jwt);
  //   setOID(parsed.id);
  // }, [jwt]);

  useEffect(() => {
    if (!jwt || !companyID) return;
    const GetEmployees = async () => {
      const searchValue = value.trim() || "";
      if (searchValue.length >= 2 || searchValue.length === 0) {
        const res = await companyController.getCompanyEmployees({
          jwt,
          companyId: companyID,
          page: currentPage,
          size: RowsPerPage,
          search: searchValue,
        });
        const rootAdmin = res.data.content.find(
          (user) => user.roleName === "Root Admin",
        );
        setOID(rootAdmin?.userId);
        setData(res?.data?.content);
        setTotalPages(res?.data?.totalPages);
        setTotalElements(res?.data?.totalElements);
      }
    };
    GetEmployees();
  }, [jwt, companyID, currentPage, RowsPerPage, value, refreshEmployees]);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await CountriesController.getCountries();
        const backendData = response?.data;
        if (Array.isArray(backendData)) {
          setCountries(
            backendData.map((c) => ({
              code: c.countryCode,
              label: c.countryName,
              dialCode: c.suffix,
            })),
          );
        } else setCountries([]);
      } catch {
        setCountries([]);
      }
    };
    loadCountries();
  }, [data]);
  const handleDeleteEmp = async () => {
    const Pjwt = Utils.parseJwt(jwt);
    const ownerID = Pjwt.id;
    if (ownerID === userId) {
      toast.error("can't delete the owner");
      return;
    }
    const removeEmployeeRequestDTO = {
      companyID: userService.getCompID(),
      userID: userId,
    };
    const deleteCompanyEmployee = await companyController.deleteCompanyEmployee(
      {
        removeEmployeeRequestDTO: removeEmployeeRequestDTO,
        Authorization: userService.getUser(),
      },
    );
    if (deleteCompanyEmployee.data) {
      setactiondiv(false);
      setRefreshEmployees((prev) => !prev);
    }
  };

  const handleSetEmployeeEnabled = async (employee, enabled) => {
    if (statusRequestPending.current) return;
    if (employee.userId === OID || employee.roleName === "Root Admin") {
      toast.error("Cannot change the company owner's status");
      return;
    }

    statusRequestPending.current = true;
    setUpdatingUserId(employee.userId);
    try {
      const response = await companyController.Enableordisableacompanyemployee({
        request: {
          companyID,
          userID: employee.userId,
          enabled,
        },
        Authorization: userService.getUser(),
      });

      if (response?.status >= 200 && response?.status < 300 && response.data !== false) {
        setOpenIndex(null);
        setRefreshEmployees((prev) => !prev);
        toast.success(`User ${enabled ? "enabled" : "disabled"} successfully`);
      } else {
        toast.error(`Failed to ${enabled ? "enable" : "disable"} user`);
      }
    } catch {
      toast.error(`Failed to ${enabled ? "enable" : "disable"} user`);
    } finally {
      statusRequestPending.current = false;
      setUpdatingUserId(null);
    }
  };
  return (
    <div className="content-managing-container">
      <div className="content-managing-action-section">
        {actiondiv && (
          <div
            className="user-popup-container"
            onClick={() => setactiondiv(false)}
          >
            <div
              className="popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="deletion-popup-content">
                <button
                  type="button"
                  className="user-popup-close"
                  onClick={() => setactiondiv(false)}
                  aria-label="Close delete user popup"
                >
                  <CloseIcon />
                </button>
                <div className="delete-user-icon">
                  <BinIcon />
                </div>
                <div className="delete-user-text">
                  <div className="delete-user-title">Delete User</div>
                  <div className="delete-user-description">
                    Are you sure you want to delete this user. This action
                    cannot be undone. This user will be deleted forever.
                  </div>
                </div>
                <div className="delete-user-buttons">
                  <div
                    className="delete-user-action-button"
                    onClick={() => handleDeleteEmp()}
                  >
                    Delete
                  </div>
                  <div
                    className="cancel-delete-user-button"
                    onClick={() => setactiondiv(false)}
                  >
                    Cancel
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="user-management-search-section">
          <div className="user-management-search-bar">
            <div className="user-management-search-bar-place-holder">
              <div className="search-bar-searchicon">
                <SearchIcon />
              </div>
              <input
                className="user-search-bar-input"
                placeholder="Search"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>
          {/* <div className="user-management-filter-users">
            <div className="user-management-filter-content">
              <div className="user-management-filter-icon">
                <FilterIcon />
              </div>
              <div className="user-management-filter-text">Filter</div>
            </div>
          </div> */}
        </div>
        <div className="user-management-export-container">
          <div className="user-management-export-container-content">
            <div className="user-management-export-icon">
              <ExportIcon />
            </div>
            <div className="user-management-export-text">Export</div>
          </div>
        </div>
      </div>
      <div className="user-info-display-table">
        <div className="user-info-table">
          <div className="table-header-row">
            <div className="cell-content-user-name">
              <div className="cell-content-header-name-data">
                <div className="user-checkbox-cell">
                  <input
                    style={{ cursor: "pointer" }}
                    type="checkbox"
                    checked={allChecked}
                    onChange={toggleAll}
                  />
                </div>
                Users
              </div>
            </div>
            <div className="cell-content-user">Email</div>
            <div className="cell-content-data-phone">Phone Number</div>
            <div className="cell-content-data">Status</div>
            <div className="cell-content-data-roll">Role</div>
            <div className="cell-content">Actions</div>
          </div>
          {data?.map((item, index) => (
            <div className="user-table-row" key={index}>
              <div className="cell-content-user-name">
                <div className="cell-content-user-name-data">
                  <div className="user-checkbox-cell">
                    <input
                      style={{ cursor: "pointer" }}
                      type="checkbox"
                      checked={selected.includes(item.userId)}
                      onChange={() => {
                        toggleOne(item.userId);
                      }}
                    />
                  </div>
                </div>
                <div className="emp-prof-name">
                  {item.profilePictureUrl === null ? (
                    <AccCyrcleIcon />
                  ) : (
                    <img
                      src={item.profilePictureUrl}
                      className="emp-profile-pic"
                      alt="wwwww"
                    />
                  )}

                  <div className="user-table-emp-name">
                    {item.firstName} {item.lastName}
                  </div>
                </div>
              </div>
              <div className="cell-content-user">{item.email}</div>
              <div className="cell-content-data-phone">
                {(() => {
                  const country = countries.find(
                    (c) => String(c.dialCode) === String(item.suffix),
                  );
                  const countryCode = country?.code;
                  return (
                    <>
                      {countryCode && (
                        <ReactCountryFlag
                          countryCode={countryCode}
                          svg
                          style={{
                            width: "1.5em",
                            height: "1.5em",
                            marginRight: "0.5em",
                          }}
                        />
                      )}
                      {item.phoneNumber}
                    </>
                  );
                })()}
              </div>
              <div className="cell-content-data">
                {item.employmentStatus === "ACTIVE" ? (
                  <div className="status-cell">
                    <Active />
                    <div className="status-cell-disc">
                      <div className="">{formatStatus(item.employmentStatus)}</div>
                      <div className="">
                        {new Date(item.employmentStartDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          },
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="status-cell">
                    <Waiting />
                    <div className="status-cell-disc">
                      <div className="">{formatStatus(item.employmentStatus)}</div>
                      <div className="">
                        {new Date(item.employmentStartDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          },
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="cell-content-data-res">
                {item.employmentStatus === "ACTIVE" ? (
                  <div className="status-cell">
                    <div className="status-cell-disc">
                      <div className="res-emp-status-cell">
                        <Active />
                        {formatStatus(item.employmentStatus)}
                      </div>
                      <div className="">
                        {new Date(item.employmentStartDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          },
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="status-cell">
                    <Waiting />
                    <div className="status-cell-disc">
                      <div className="">{formatStatus(item.employmentStatus)}</div>
                      <div className="">
                        {new Date(item.employmentStartDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          },
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="cell-content-data-roll">
                {OID === item.userId ? "Company Owner" : item.roleName}
              </div>
              <div className="cell-content">
                <div
                  className={
                    OID === item.userId
                      ? "more-actions-icon-owner"
                      : "more-actions-icon"
                  }
                  onClick={() => handleactiondiv(index)}
                >
                  <ThreeDots />
                </div>
                {/*************************************************************** */}
                <div
                  className={
                    OID === item.userId
                      ? "emp-action-bottons-owner"
                      : "emp-action-bottons"
                  }
                >
                  <div
                    className="edit-employess-data-action-botton"
                    onClick={() => handleEditClick(item.userId, item.roleName)}
                  >
                    <EditDetails stroke="#4072C8" />
                  </div>
                  <div
                    className="delete-employess-data-action-botton"
                    onClick={() => {
                      setactiondiv(true);
                      setOpenIndex(null);
                      setUserId(item.userId);
                    }}
                  >
                    <BinIcon
                      showOuterCircle={false}
                      showInnerCircle={false}
                      width="22.5px"
                      height="24px"
                    />
                  </div>
                </div>
                {/*************************************************************** */}

                {openIndex === index && (
                  <div ref={popupRef} className="actions-popup">
                    <div
                      className="popup-rows"
                      onClick={() =>
                        handleEditClick(item.userId, item.roleName)
                      }
                    >
                      <div className="popup-rows-icon">
                        <EditDetails />
                      </div>
                      <div className="user-edit-details-text">Edit Details</div>
                    </div>
                    <div
                      className="popup-rows-middle"
                      onClick={() => {
                        setactiondiv(true);
                        setOpenIndex(null);
                        setUserId(item.userId);
                      }}
                    >
                      <div className="popup-rows-icon">
                        <RemoveUser />
                      </div>
                      <div className="user-remove-user-text">Remove User</div>                    
                    </div>
                    <div
                      className="popup-user-status-action popup-user-enable"
                      aria-disabled={updatingUserId !== null}
                      onClick={() => handleSetEmployeeEnabled(item, true)}
                    >
                      {updatingUserId === item.userId ? "Updating..." : "Enable User"}
                    </div>
                    <div
                      className="popup-user-status-action popup-user-disable"
                      aria-disabled={updatingUserId !== null}
                      onClick={() => handleSetEmployeeEnabled(item, false)}
                    >
                      {updatingUserId === item.userId ? "Updating..." : "Disable User"}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="nav-bar-section">
        {/* <div className="nav-bar-functionality">
          <div className="functionality-description">Rows per page</div>
          <div className="number-of-rows-displayed">
            <div className="number-of-rows-displayed-container">
              <input
                className="number-displayed"
                type="number"
                value={RowsPerPage}
                onChange={handleChange}
                min={1}
                max={10}
              />
            </div>
          </div>
          <div className="over-all-rows">of {totalElements} rows</div>
        </div> */}
        <div className="nav-table-bar">
          <div
            className={`nav-bar-button ${currentPage === 1 ? "disabled" : ""}`}
            onClick={() => {
              if (currentPage > 1) {
                setCurrentPage((p) => p - 1);
              }
            }}
          >
            <ArrowBackIcon />
          </div>

          <div className="nav-bar-buttons">
            {getPages().map((item, i) =>
              item === "ellipsis" ? (
                <div className="three-dots-nav" key={`e-${i}`}>
                  ...
                </div>
              ) : (
                <div
                  key={item}
                  className={`nav-page-number ${
                    currentPage === item ? "active-page" : ""
                  }`}
                  onClick={() => setCurrentPage(item)}
                >
                  {item}
                </div>
              ),
            )}
          </div>

          <div
            className={`nav-bar-button ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            onClick={() => {
              if (currentPage < totalPages) {
                setCurrentPage((p) => p + 1);
              }
            }}
          >
            <ArrowFront />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserManagmentUsers;
